<onyx-section [heading]="`${I18N}.heading`" justify="right">
  <div rightHeading [formGroup]="form()" class="optional">
    <h6>{{ 'labels.optional' | translate }}</h6>

    <onyx-toggle [formControl]="form().controls.hasDailyReturns"></onyx-toggle>

    @if (isInvalid()) {
      <h6 class="error">{{ `${I18N}.requiredData` | translate }}</h6>
    }
  </div>

  @if (form().controls.hasDailyReturns.value) {
    <div class="container">
      <onyx-input-label
        [label]="`${I18N}.workDays` | translate"
      ></onyx-input-label>

      <onyx-chips
        [chips]="CHIPS"
        [(activeValues)]="days"
        variant="secondary"
      ></onyx-chips>
    </div>
  }
</onyx-section>
